<template>
    <v-main>
      <WorkflowsHero />
      <WorkflowsFeatures/>
      <WorkflowsComparison/>
      <WorkflowsChatbots/>
      <WorkflowsWizard/>
      <WorkflowsEfficiency/>
      <RequestDemo msg="See how Yabbr Workflows can free up your team’s time and supercharge your operations." grey="true"/>
    </v-main>
</template>
  
<script>
import WorkflowsHero from './WorkflowsHero.vue'
import WorkflowsFeatures from './WorkflowsFeatures.vue'
import WorkflowsWizard from './WorkflowsWizard.vue'
import WorkflowsChatbots from './WorkflowsChatbots.vue'
import WorkflowsComparison from './WorkflowsComparison.vue'
import WorkflowsEfficiency from './WorkflowsEfficiency.vue'
import RequestDemo from './RequestDemo.vue'

export default {
  name: 'WorkflowsPage',
  components: {
    WorkflowsHero,
    WorkflowsFeatures,
    WorkflowsWizard,
    WorkflowsChatbots,
    WorkflowsComparison,
    WorkflowsEfficiency,
    RequestDemo,
  },
}
</script>
